/* global femcare */

/**
 * Google Analytics 4 events.
 */
femcare.tracking.forms = {
    /**
     * Initialize the form tracking module.
     */
    init () {
        this.formVisible();
        this.observeModalForms();

        // Use debounce to call formVisible 200ms after the user stops scrolling
        let timeout;
        $(window).on('wheel scroll resize touchstart touchmove', () => {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                this.formVisible();
            }, 200);
        });

        $(document).on('input', 'form input', (event) => {
            const $input = $(event.target);
            const $form = $input.closest('form');
            const formType = $form.data('ga-is-sample');
            const isRRForm = $form.parents('.power-reviews,.show-reviews-container').length;
            const isBVForm = $form.hasClass('bv-form');
            const isSearchForm = $form.hasClass('search-form');

            if (!isRRForm && !isBVForm && !isSearchForm) {
                this.formStarted(event, formType);
            }
        });

        $(document).on('submit', 'form', (event) => {
            const $form = $(event.target).closest('form');
            const formType = $form.data('ga-is-sample');
            const isRRForm = $form.parents('.power-reviews,.show-reviews-container').length;
            const isBVForm = $form.hasClass('bv-form');
            const isSearchForm = $form.hasClass('search-form');

            if (!isRRForm && !isBVForm && !isSearchForm) {
                this.formSubmit(formType, $form);
            }
        });
    },

    /**
     * Checks each form on the page for visibility and adds analytics tracking if visible.
     */
    formVisible () {
        $('form').each((index, element) => {
            const $element = $(element);
            const formVisible = femcare.shared.util.isAnyPartOfElementInViewport($element);

            const isRRForm = $element.parents('.power-reviews,.show-reviews-container').length;
            const isBVForm = $element.hasClass('bv-form');
            const isSearchForm = $element.hasClass('search-form');
            const isSampleForm = $element.data('ga-is-sample');

            if (formVisible && !isRRForm && !isBVForm && !isSearchForm && !isSampleForm) {
                this.addVisibleFormAnalytics($element);
            }
        });
    },

    /**
     * Adds analytics data when a form becomes visible.
     * @param {jQuery} $form - The jQuery object representing the form element.
     */
    addVisibleFormAnalytics ($form) {
        const formName = $form.data('ga-form-name');
        const formId = $form.data('ga-form-id');

        if (!$form.data('ga4_form_visible')) {
            femcare.tracking.analytics.pushEvent('ga4_form_visible', {
                form_name: formName,
                form_id: formId
            });

            // Set a flag to indicate that the event has been triggered for this form.
            $form.data('ga4_form_visible', true);
        }
    },

    /**
     * Track the event when a user starts filling out a field in a form.
     * The event is triggered for any form on the page when a user starts
     * filling out a field with the first letter.
     */
    formStarted (event, isSample) {
        const $input = $(event.target);
        const $form = $input.closest('form');

        // Check if the event has already been triggered for this input field.
        if (!$form.data('ga4_form_started')) {
            const formName = $form.data('ga-form-name');
            const formId = $form.data('ga-form-id');

            if (!isSample) {
                femcare.tracking.analytics.pushEvent('ga4_form_start', {
                    form_name: formName,
                    form_id: formId
                });
            } else if (isSample) {
                femcare.tracking.analytics.pushEvent('ga4_sample_form', {
                    action_type: 'Filling out the form',
                    step_name: 'Filling out the form',
                    step_number: 2,
                    single_item_id: formId,
                    single_item_name: formName
                });
            }

            // Set a flag to indicate that the event has been triggered for this input field.
            $form.data('ga4_form_started', true);
        }
    },

    /**
     * Track form submissions for both existing and dynamically added forms.
     */
    formSubmit (isSample, $form) {
        const formName = $form.data('ga-form-name');
        const formId = $form.data('ga-form-id');

        if (!isSample) {
            femcare.tracking.analytics.pushEvent('ga4_form_submit', {
                form_name: formName,
                form_id: formId
            });
        } else if (isSample) {
            femcare.tracking.analytics.pushEvent('ga4_sample_form', {
                action_type: 'Confirmation',
                step_name: 'Confirmation',
                step_number: 3,
                single_item_id: formId,
                single_item_name: formName
            });
        }

    },

    /**
     * Add analytics when sample form becomes visible.
     */
    sampleFormVisible (form) {
        const $form = $(form);
        const sampleId = $form.data('ga-form-id');
        const sampleName = $form.data('ga-form-name');

        femcare.tracking.analytics.pushEvent('ga4_sample_form', {
            action_type: 'Initiate request form',
            step_name: 'Initiate request form',
            step_number: 1,
            single_item_id: sampleId,
            single_item_name: sampleName
        });
    },

    /**
     * Observes modals for when they become visible and triggers form analytics.
     * Uses MutationObserver to detect when the 'displayed' class is added to modals.
     */
    observeModalForms () {
        const self = this;
        const modals = document.querySelectorAll('.modal');

        modals.forEach((modal) => {
            const observer = new MutationObserver((mutations) => {
                const hasClassChange = mutations.some((mutation) => {
                    return mutation.attributeName === 'class';
                });

                if (hasClassChange && modal.classList.contains('displayed')) {
                    self.checkModalForms(modal);
                }
            });

            observer.observe(modal, { attributes: true });
        });
    },

    /**
     * Checks for forms inside a modal and triggers visibility analytics.
     * @param {HTMLElement} modal - The modal element that became visible.
     */
    checkModalForms (modal) {
        const self = this;
        const $forms = $(modal).find('form');

        $forms.each((index, element) => {
            const $element = $(element);
            const isRRForm = $element.parents('.power-reviews,.show-reviews-container').length;
            const isBVForm = $element.hasClass('bv-form');
            const isSearchForm = $element.hasClass('search-form');
            const isSampleForm = $element.data('ga-is-sample');

            if (!isRRForm && !isBVForm && !isSearchForm && !isSampleForm) {
                self.addVisibleFormAnalytics($element);
            }
        });
    }
};
